import script from "./ProductPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPicker.vue?vue&type=script&setup=true&lang=js"

import "./ProductPicker.vue?vue&type=style&index=0&id=77901662&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77901662"]])

export default __exports__